import script from "./RecentEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentEvents.vue?vue&type=script&setup=true&lang=js"

import "./RecentEvents.vue?vue&type=style&index=0&id=440a87e6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-440a87e6"]])

export default __exports__